import { isTabbable } from 'tabbable';
function getTabbableBoundary(root) {
    const allElements = [];
    function walk(el) {
        if (el instanceof HTMLElement) {
            allElements.push(el);
            if (el.shadowRoot && el.shadowRoot.mode === 'open') {
                walk(el.shadowRoot);
            }
        }
        [...el.querySelectorAll('*')].map((e) => walk(e));
    }
    walk(root);
    const start = allElements.find(el => isTabbable(el)) || null;
    const end = allElements.reverse().find(el => isTabbable(el)) || null;
    return { start, end };
}
export { getTabbableBoundary };
